module.exports = __webpack_public_path__ + "static/image2_en-1f09965dc9b4fc0b68b288419dc99089.png";